export const PHONE_THUMBNAILS_LIMIT = 2
export const DEFAULT_THUMBNAILS_LIMIT = 3

export enum BundleShippingType {
  Integrated = 'integrated',
  CustomOrNoShipping = 'custom_or_no_shipping',
  ShippingUnavailable = 'shipping_unavailable',
}
